module.exports = "<h1 i18n=\"@@pageNotFound\">The page you requested was not found.</h1>\n"